import { defineStore } from 'pinia'
import api from '@/plugins/axios'

export const useMessagesStore = defineStore('messages', {
  state: () => ({
    messages: [],
    currentConversation: null,
    loading: false,
    showCreditsModal: false,
    hasError: false,
    errorType: null,
    errorMessage: null
  }),
  actions: {
    async fetchMessages (conversationId) {
      this.loading = true
      this.hasError = false
      this.errorType = null
      this.errorMessage = null

      try {
        const response = await api.get(`/conversation/${conversationId}`)
        this.messages = response.data.messages
        this.currentConversation = {
          conversation_id: response.data.conversation_id,
          scenario: response.data.scenario,
          language: response.data.language
        }
      } catch (error) {
        console.error('Error fetching messages:', error)
        this.hasError = true
        this.errorType = 'fetch'
        this.errorMessage = error.response?.data?.message || 'Failed to load conversation'
      } finally {
        this.loading = false
      }
    },
    async postMessage (message) {
      console.log('postMessage', message)
      try {
        this.loading = true
        this.hasError = false
        this.errorType = null
        this.errorMessage = null

        const response = await api.patch(`/conversation/${this.currentConversation.conversation_id}`, {
          content: message.content,
          role: 'user'
        })
        // Extract the message ID from the response and the message from the AI
        // and push it to the messages array
        this.messages.push({
          message_id: response.data.messages[0].message_id,
          content: message.content,
          role: 'user'
        })
        this.messages.push({
          message_id: response.data.messages[1].message_id,
          content: response.data.messages[1].content,
          role: 'ai'
        })
      } catch (error) {
        console.error('Error posting message:', error)
        this.hasError = true

        if (error.response && error.response.status === 403) {
          this.errorType = 'credits'
          this.showCreditsModal = true
          this.errorMessage = 'You have reached your message limit'
        } else {
          this.errorType = 'send'
          this.errorMessage = error.response?.data?.message || 'Failed to send message'
        }
      } finally {
        this.loading = false
      }
    },
    setSelectedConversation (conversation) {
      console.log('Selecting conversation', conversation)
      this.messages = conversation.messages || []
      this.currentConversation = conversation
      this.loading = false
      this.hasError = false
      this.errorType = null
      this.errorMessage = null
    },
    resetState () {
      this.messages = []
      this.currentConversation = null
      this.loading = false
      this.showCreditsModal = false
      this.hasError = false
      this.errorType = null
      this.errorMessage = null
    }
  }
})
